// ============================================================================
// post-client-mod -- usePost Hook
//
// 获取单篇文章详情。
// 支持 SSR：如果传入 initialData，直接使用（不请求）。
// ============================================================================
import { useState, useEffect, useCallback, useRef } from 'react';
import { getPostApiClient } from '../post-api-client.js';
/**
 * 获取单篇文章详情
 */
export function usePost(id, initialData) {
    const [post, setPost] = useState(initialData ?? null);
    const [loading, setLoading] = useState(!initialData);
    const [error, setError] = useState(null);
    // 使用 useRef 追踪首次渲染，在 SSR hydration + 纯 CSR 场景下都可靠
    const isFirstRender = useRef(true);
    // 追踪当前加载的 id，用于检测 id 变化时清除旧数据
    const loadedIdRef = useRef(undefined);
    const fetchPost = useCallback(async () => {
        if (id === undefined) {
            setLoading(false);
            return;
        }
        // 首次渲染时如果有 initialData，跳过请求（SSR hydration 场景）
        if (isFirstRender.current) {
            isFirstRender.current = false;
            if (initialData) {
                loadedIdRef.current = id;
                return;
            }
        }
        // id 变化时立即清除旧数据，避免显示上一篇文章内容
        if (loadedIdRef.current !== id) {
            loadedIdRef.current = id;
            setPost(null);
        }
        setLoading(true);
        setError(null);
        try {
            const result = await getPostApiClient().getPost(id);
            setPost(result);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '获取文章失败';
            setError(message);
            setPost(null);
        }
        finally {
            setLoading(false);
        }
    }, [id, initialData]);
    useEffect(() => {
        fetchPost();
    }, [fetchPost]);
    return { post, loading, error, refresh: fetchPost };
}
//# sourceMappingURL=use-post.js.map